import React from "react";
import LudDashboardModal from "../../modals/LudDashboardModal";

// First step of activating an application: does the store already have an
// account with it (Integrate) or does it still need to register (Subscribe)?
export default function ActivateModal({ open, appName, t, onChoose, onClose }) {
  return (
    <LudDashboardModal open={open} title={t.activate.title(appName)} size="sm" onClose={onClose}>
      <p className="lud-app-lead">{t.activate.question}</p>
      <div className="lud-app-choice-grid">
        <button type="button" className="lud-app-choice" onClick={() => onChoose("subscribe")}>
          <strong>{t.activate.subscribe}</strong>
          <span>{t.activate.subscribeHint}</span>
        </button>
        <button type="button" className="lud-app-choice" onClick={() => onChoose("integrate")}>
          <strong>{t.activate.integrate}</strong>
          <span>{t.activate.integrateHint}</span>
        </button>
      </div>
    </LudDashboardModal>
  );
}
